<form [formGroup]="form" (ngSubmit)="actualizar()" class="space-y-6">
    <!-- Sección: Datos requeridos -->
    <div>
        <h3 class="text-lg font-semibold mb-4">Datos requeridos</h3>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div class="field-wrapper">
                <label for="nro_licencia">Número de Licencia *</label>
                <p-inputnumber id="nro_licencia" formControlName="nro_licencia" placeholder="Número de licencia" [ngClass]="{ 'p-invalid': form.get('nro_licencia')?.invalid && form.get('nro_licencia')?.touched }" />
                @if (form.get('nro_licencia')?.touched && form.get('nro_licencia')?.invalid) {
                    <small class="p-error">
                        @if (form.get('nro_licencia')?.errors?.['required']) {
                            Este campo es obligatorio.
                        }
                        @if (!form.get('nro_licencia')?.invalid || !form.get('nro_licencia')?.touched) {
                            &nbsp;
                        }
                    </small>
                }
            </div>

            <div class="field-wrapper">
                <label for="licencia_tipo">Tipo de Licencia *</label>
                <p-select
                    [showClear]="true"
                    id="licencia_tipo"
                    formControlName="licencia_tipo"
                    [options]="opcionesSelect.tipoLicencia"
                    placeholder="Seleccione una opción"
                    appendTo="body"
                    optionLabel="siglas"
                    [ngClass]="{ 'p-invalid': form.get('licencia_tipo')?.invalid && form.get('licencia_tipo')?.touched }"
                />
                @if (form.get('licencia_tipo')?.touched && form.get('licencia_tipo')?.invalid) {
                    <small class="p-error">
                        @if (form.get('licencia_tipo')?.errors?.['required']) {
                            Este campo es obligatorio.
                        }
                        @if (!form.get('licencia_tipo')?.invalid || !form.get('licencia_tipo')?.touched) {
                            &nbsp;
                        }
                    </small>
                }
            </div>

            <div class="field-wrapper">
                <label for="vencimiento_licencia">Vencimiento de Licencia *</label>
                <p-datepicker
                    class="w-full"
                    appendTo="body"
                    [iconDisplay]="'input'"
                    [showIcon]="true"
                    id="vencimiento_licencia"
                    formControlName="vencimiento_licencia"
                    dateFormat="dd/mm/yy"
                    placeholder="dd/mm/aaaa"
                    [style]="{ width: '100%' }"
                    [inputStyle]="{ width: '100%' }"
                    [ngClass]="{ 'p-invalid': form.get('vencimiento_licencia')?.invalid && form.get('vencimiento_licencia')?.touched }"
                />
                @if (form.get('vencimiento_licencia')?.touched && form.get('vencimiento_licencia')?.invalid) {
                    <small class="p-error">
                        @if (form.get('vencimiento_licencia')?.errors?.['required']) {
                            Se requiere una fecha.
                        }
                        @if (!form.get('vencimiento_licencia')?.invalid || !form.get('vencimiento_licencia')?.touched) {
                            &nbsp;
                        }
                    </small>
                }
            </div>
        </div>
    </div>

    <!-- Sección: Datos complementarios -->
    <div class="pt-6 border-t mt-6">
        <h3 class="text-lg font-semibold mb-4">Datos complementarios</h3>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div class="field-wrapper">
                <label for="llave">Llave GPS</label>
                <input id="llave" pInputText formControlName="llave" placeholder="Código de llave" />
            </div>

            <div class="field-wrapper">
                <label for="tipo">Tipo de Conductor</label>
                <p-select [showClear]="true" id="tipo" formControlName="tipo" optionLabel="siglas" [options]="opcionesSelect.tipoConducir" placeholder="Seleccione" appendTo="body" />
            </div>

            <div class="field-wrapper">
                <label for="md_nivel">MD Nivel</label>
                <p-select [showClear]="true" id="md_nivel" formControlName="md_nivel" optionLabel="siglas" [options]="opcionesSelect.nivelMd" appendTo="body" placeholder="Seleccione" />
            </div>
        </div>
    </div>

    <!-- Botones -->
    <div class="flex justify-end gap-3 mt-6">
        <button pButton type="button" label="Cancelar" class="p-button-secondary" (click)="cancelar()"></button>
        <button pButton type="submit" label="Guardar" [disabled]="form.invalid"></button>
    </div>
</form>
